import imgPuestaTierra from '../img/08_puesta_tierra_industrial.webp';
import imgTransformadores from '../img/03_mantenimiento_subestacion.webp';
import imgCalidadEnergia from '../img/06_inspeccion_switchgear.webp';
import imgPlanos from '../img/05_diseno_planos_electricos.webp';
import imgPaneles from '../img/04_centro_control_industrial.webp';
import imgCondensadores from '../img/01_tecnicos_panel_electrico.webp';
import imgMantenimiento from '../img/02_mantenimiento_panel_electrico.webp';
import imgTermografia from '../img/07_termografia_panel_electrico.webp';

export const MAIN_SERVICE_GROUPS = [
  {
    id: 'puesta-a-tierra',
    title: 'Sistema de puesta a tierra y protección atmosférica',
    shortTitle: 'Puesta a tierra y protección atmosférica',
    summary: 'Diseño, mantenimiento e inspección certificada de sistemas de aterrizaje y protección contra descargas atmosféricas.',
    image: imgPuestaTierra,
    imageAssetName: 'siesa_service_puesta_a_tierra_v1.webp',
    imageAlt: 'Medición técnica de un sistema de puesta a tierra.',
    highlights: [
      'Medición de resistividad del terreno.',
      'Protección atmosférica y pararrayos.',
      'Protección contra transitorios (DPS).',
      'Emisión de certificaciones técnicas.',
    ],
    scope: [
      'Medición de resistividad del terreno.',
      'Medición de resistencia del conductor de tierra.',
      'Mantenimiento e instalación de protección atmosférica.',
      'Suministro e instalación de protección de transitorios (DPS).',
      'Mantenimiento de sistemas de puesta a tierra.',
      'Emisión de certificaciones.',
    ],
  },
  {
    id: 'transformadores',
    title: 'Mantenimiento de transformadores en aceite y seco',
    shortTitle: 'Mantenimiento de transformadores',
    summary: 'Diagnóstico integral, pruebas eléctricas y reacondicionamiento para transformadores industriales de distribución y potencia.',
    image: imgTransformadores,
    imageAssetName: 'siesa_service_transformadores_v1.webp',
    imageAlt: 'Mantenimiento preventivo de un transformador eléctrico.',
    highlights: [
      'Análisis cromatográfico de aceite.',
      'Pruebas dieléctricas y TTR.',
      'Filtraje y regeneración de aceite.',
      'Reparación de fugas y mantenimiento.',
    ],
    scope: [
      'Análisis cromatográficos del aceite.',
      'Pruebas de factor de potencia.',
      'Pruebas TTR.',
      'Pruebas de aislamiento.',
      'Corrección de fugas.',
      'Filtraje de aceite.',
      'Pintura y reparación de fugas.',
    ],
  },
  {
    id: 'otros-servicios',
    title: 'Otros servicios eléctricos y de ingeniería',
    shortTitle: 'Otros servicios eléctricos y de ingeniería',
    summary: 'Soluciones integrales de automatización, calidad de energía, ensamblaje de tableros, termografía y planos digitales.',
    image: imgCalidadEnergia,
    imageAssetName: 'siesa_service_ingenieria_general_v1.webp',
    imageAlt: 'Ingeniero inspeccionando infraestructura eléctrica de alta tensión.',
    highlights: [
      'Estudios de calidad de energía.',
      'Diseño y digitalización con QR.',
      'Paneles, VDF y transferencias.',
      'Mantenimientos y termografías.',
    ],
    scope: [
      'Estudios de calidad de energía mediante analizador de red.',
      'Gestión energética y auditorías energéticas.',
      'Monitoreo remoto de la calidad energética en la empresa.',
      'Diseño y elaboración de planos eléctricos.',
      'Digitalización y lectura de planos mediante códigos QR.',
      'Ensamblaje de paneles eléctricos y armarios de control.',
      'Ensamblaje de arrancadores con VDF y softstarter.',
      'Ensamblaje de transferencias automáticas.',
      'Ensamblaje de bancos de condensadores fijos y automáticos.',
      'Mantenimientos predictivos y correctivos en campo.',
      'Termografías e inspección infrarroja de puntos calientes.',
    ],
  },
];

export const SERVICES = [
  {
    id: 'puesta-a-tierra',
    title: 'Puesta a tierra y protección atmosférica',
    summary: 'Sistemas de protección confiables y seguros, con medición certificada.',
    image: imgPuestaTierra,
    imageAssetName: 'siesa_service_puesta_a_tierra_v1.webp',
    imageAlt: 'Medición técnica de un sistema de puesta a tierra.',
    scope: [
      'Medición de resistividad del terreno.',
      'Medición de resistencia del conductor de tierra.',
      'Mantenimiento e instalación de protección atmosférica.',
      'Suministro e instalación de protección de transitorios (DPS).',
      'Mantenimiento de sistemas de puesta a tierra.',
      'Emisión de certificaciones.',
    ],
  },
  {
    id: 'transformadores',
    title: 'Mantenimiento de transformadores',
    summary: 'Mantenimiento preventivo y correctivo de transformadores en aceite y seco.',
    image: imgTransformadores,
    imageAssetName: 'siesa_service_transformadores_v1.webp',
    imageAlt: 'Mantenimiento preventivo de un transformador eléctrico.',
    scope: [
      'Análisis cromatográficos del aceite.',
      'Pruebas de factor de potencia.',
      'Pruebas TTR.',
      'Pruebas de aislamiento.',
      'Corrección de fugas.',
      'Filtraje de aceite.',
      'Pintura y reparación de fugas.',
    ],
  },
  {
    id: 'calidad-de-energia',
    title: 'Calidad y gestión de energía',
    summary: 'Mejora de la eficiencia y la calidad del sistema eléctrico.',
    image: imgCalidadEnergia,
    imageAssetName: 'siesa_service_calidad_energia_v1.webp',
    imageAlt: 'Ingeniero inspeccionando infraestructura eléctrica de alta tensión.',
    scope: [
      'Estudio de calidad de energía mediante analizador de red.',
      'Gestión energética.',
      'Auditorías energéticas.',
      'Monitoreo remoto de la calidad energética en la empresa.',
    ],
  },
  {
    id: 'planos',
    title: 'Diseño y digitalización de planos',
    summary: 'Organización y acceso digital a la información del proyecto.',
    image: imgPlanos,
    imageAssetName: 'siesa_service_digitalizacion_planos_v1.webp',
    imageAlt: 'Medición técnica de un sistema de puesta a tierra.',
    scope: [
      'Diseño y elaboración de planos eléctricos.',
      'Digitalización y lectura de planos mediante códigos QR.',
    ],
  },
  {
    id: 'paneles',
    title: 'Paneles eléctricos y automatización',
    summary: 'Diseño, fabricación e integración de tableros.',
    image: imgPaneles,
    imageAssetName: 'siesa_service_automatizacion_v1.webp',
    imageAlt: 'Ingeniero inspeccionando infraestructura eléctrica de alta tensión.',
    scope: [
      'Ensamblaje de paneles eléctricos.',
      'Ensamblaje de arrancadores con VDF y softstarter.',
      'Ensamblaje de transferencias automáticas.',
    ],
  },
  {
    id: 'bancos-de-condensadores',
    title: 'Bancos de condensadores',
    summary: 'Corrección del factor de potencia y eficiencia.',
    image: imgCondensadores,
    imageAssetName: 'siesa_service_bancos_condensadores_v1.webp',
    imageAlt: 'Mantenimiento preventivo de un transformador eléctrico.',
    scope: ['Ensamblaje de bancos de condensadores fijos y automáticos.'],
  },
  {
    id: 'mantenimiento',
    title: 'Mantenimiento eléctrico',
    summary: 'Servicios preventivos y correctivos en campo.',
    image: imgMantenimiento,
    imageAssetName: 'siesa_service_mantenimiento_v1.webp',
    imageAlt: 'Medición técnica de un sistema de puesta a tierra.',
    scope: ['Mantenimientos predictivos y correctivos.'],
  },
  {
    id: 'termografia',
    title: 'Termografía y diagnóstico',
    summary: 'Detección temprana de fallas y sobrecargas.',
    image: imgTermografia,
    imageAssetName: 'siesa_service_termografia_v1.webp',
    imageAlt: 'Ingeniero inspeccionando infraestructura eléctrica de alta tensión.',
    scope: ['Termografías.'],
  },
];

export const FEATURED_SERVICE_IDS = [
  'puesta-a-tierra',
  'transformadores',
  'calidad-de-energia',
  'paneles',
];
